export const DOMAIN = process.env.NEXT_PUBLIC_DOMAIN;
export const UNIVERSAL_ADMIN = process.env.NEXT_PUBLIC_UNIVERSAL_ADMIN;
export const V4_UNIVERSAL_ADMIN = process.env.NEXT_PUBLIC_V4_UNIVERSAL_ADMIN;
export const YANDEX_CLOUD = process.env.NEXT_PUBLIC_YANDEX_CLOUD;
export const LINK_PREFIX = `${UNIVERSAL_ADMIN.replace('/api/1457', '')}/static/`;
export const PDF_GEN = process.env.NEXT_PUBLIC_ADMIN_PDF_GEN;
export { CONTACTS } from './contacts';
export {
  infoAboutLandscaping,
  infoAboutProject,
  roomsInfo,
} from './info-project';
export {
  mapFilters,
  mapPins,
} from './map-data';
export { routesGeneralPage } from './routes-general-page';
export { SCHEMA } from './schema';
export { redBookScroll, scrollInfo, scrollInfrastructure, scrollLocation } from './scroll-info';
export { URLS } from './urls';
export { hideData, hideDataMobile, visibleData } from './wb-data';
